import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import {SMCCheckbox} from '../../../components/Simple/SMCCheckbox';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCButton from '../../../components/Simple/SMCButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';


function GatewayWizardStepThree({
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        onRequestClose,
        setWizardStep,
        finishWizard,
        firewall, setFirewall,
        applicationControlAndUrlFiltering, setApplicationControlAndUrlFiltering,
        ips, setIps,
        traditionalAntiVirus, setTraditionalAntiVirus,
        antiSpam, setAntiSpam,
        qos, setQos,
        remoteAccessVpn, setRemoteAccessVpn,
        siteToSiteVpn, setSiteToSiteVpn,
        userAwareness, setUserAwareness,
        antiVirus, setAntiVirus,
        antiBot, setAntiBot
    } = wizardVars;

    const backButtonFunction = () => {
        setWizardStep(step => step - 1);
    }

    return (
        <>
            <SMCModalBody lineHeight="29px">
                <SMCLabel bold>{t('SMP.PLAN.NEW_PLAN_SB.LINE1')}</SMCLabel>
                <SMCCheckbox
                    checked={firewall}
                    onChange={e => setFirewall(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.FIREWALL")}
                />
                <SMCCheckbox
                    checked={applicationControlAndUrlFiltering}
                    onChange={e => setApplicationControlAndUrlFiltering(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.APP_FILTER")}
                />
                <SMCCheckbox
                    checked={ips}
                    onChange={e => setIps(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.IPS")}
                />
                <SMCCheckbox
                    checked={traditionalAntiVirus}
                    onChange={e => setTraditionalAntiVirus(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.T_ANTI_VIRUS")}
                />
                <SMCCheckbox
                    checked={antiSpam}
                    onChange={e => setAntiSpam(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.ANTI_SPAM")}
                />
                <SMCCheckbox
                    checked={qos}
                    onChange={e => setQos(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.QOS")}
                />
                <SMCCheckbox
                    checked={remoteAccessVpn}
                    onChange={e => setRemoteAccessVpn(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.R_A_VPN")}
                />
                <SMCCheckbox
                    checked={siteToSiteVpn}
                    onChange={e => setSiteToSiteVpn(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.S_TO_S_VPN")}
                />
                <SMCCheckbox
                    checked={userAwareness}
                    onChange={e => setUserAwareness(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.USER_AWARENESS")}
                />
                <SMCCheckbox
                    checked={antiVirus}
                    onChange={e => setAntiVirus(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.ANTI_VIRUS")}
                />
                <SMCCheckbox
                    checked={antiBot}
                    onChange={e => setAntiBot(e.target.checked)}
                    label={t("SMP.PLAN.NEW_PLAN_SB.ANTI_BOT")}
                />
                <div style={{ lineHeight: '0px', paddingTop: '10px' }}>
                    <SMCLabel>{t("SMP.PLAN.NEW_PLAN_SB.LINE2")}</SMCLabel>
                </div>
                <SMCLabel>{t("SMP.PLAN.NEW_PLAN_SB.LINE3")}</SMCLabel>
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={backButtonFunction} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="arrow-circle-left" />
                    {t('SMC_GEN_WIZBACK')}
                </SMCButton>
                <SMCButton onClick={finishWizard} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onRequestClose}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default GatewayWizardStepThree;